import { Link, notFound, useParams, useSearch } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { studioQuery } from '@/queries';
import { ArrowLeft } from '@phosphor-icons/react';

import { EmptyState } from '@/components/ui';
import { StudioClient } from '@/components/studio/studio-client';

export default function StudioPage() {
  const { productId } = useParams({ strict: false }) as { productId: string };
  const query = useSearch({ strict: false }) as { method?: string };
  const {
    product,
    methods,
    designs: readyDesigns,
  } = useSuspenseQuery(studioQuery(productId)).data;

  // A garment that does not exist is a 404. **No active decoration method is
  // not.** Those two were one condition, so with every method switched off
  // pending the rate card, "Open the studio" on /custom answered "We could not
  // find that." for a garment that page had just listed.
  //
  // /custom already says the true thing in this situation, in an EmptyState:
  // the prices are not set, call the studio. This page threw a 404 instead, one
  // click later. R-261, and it is unblocked by Q-13 rather than by code.
  if (!product) throw notFound();

  return (
    <div className="mx-auto max-w-[1180px] px-[30px] py-8">
      <Link
        to="/custom"
        className="inline-flex items-center gap-2 py-2 text-sm font-semibold text-muted hover:text-ink"
      >
        <ArrowLeft size={16} weight="bold" aria-hidden />
        All garments
      </Link>

      {methods.length === 0 ? (
        <div className="mt-6">
          <EmptyState
            title="Decoration prices are not set yet"
            body="Call the studio and we will quote your job by hand while the price list is finished."
          />
        </div>
      ) : (
      <div className="mt-4">
        <StudioClient
          product={product}
          methods={methods}
          readyDesigns={readyDesigns}
          initialMethodKey={query.method}
        />
      </div>
      )}
    </div>
  );
}
